// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Checkbox-module__wrapper--1UzFb{display:flex;align-items:center;flex-shrink:0}.Checkbox-module__wrapper--1UzFb>*:hover{cursor:pointer}.Checkbox-module__svg--3X_46{width:1rem;height:1rem;min-width:1rem;min-height:1rem;color:#09c}.Checkbox-module__label--2r4he{margin-left:.375rem}", ""]);
// Exports
exports.locals = {
	"wrapper": "Checkbox-module__wrapper--1UzFb",
	"svg": "Checkbox-module__svg--3X_46",
	"label": "Checkbox-module__label--2r4he"
};
module.exports = exports;
